import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { RegisteredInterestService } from '@repos/interest/registered-interest.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
	UntypedFormBuilder,
	UntypedFormControl,
	UntypedFormGroup,
	Validators,
	AbstractControl,
} from '@angular/forms';
import * as LogRocket from 'logrocket';
import {
	AnalyticsEvent,
	AnalyticsService,
} from '@services/analytics/analytics.service';

@Component({
	selector: 'app-landing',
	templateUrl: './landing.component.html',
	standalone: false,
})
export class LandingComponent implements OnInit {
	emailForm: UntypedFormGroup;
	submitted: boolean;
	successful: boolean;

	constructor(
		public auth: AngularFireAuth,
		public router: Router,
		private registerIntService: RegisteredInterestService,
		private snackbar: MatSnackBar,
		private formBuilder: UntypedFormBuilder,
		private analytics: AnalyticsService,
	) {}

	get email(): AbstractControl {
		return this.form.email;
	}

	// rome-ignore lint/suspicious/noExplicitAny: <explanation>
	get form(): any {
		return this.emailForm.controls;
	}

	ngOnInit(): void {
		this.emailForm = this.formBuilder.group({
			email: new UntypedFormControl('', [
				Validators.required,
				Validators.email,
			]),
		});
	}

	goToRegister(): void {
		void this.router.navigate(['/register']);
	}

	async registerInterest(): Promise<void> {
		this.submitted = true;

		if (this.emailForm.invalid) {
			return;
		}
		try {
			this.analytics.logEvent(AnalyticsEvent.LANDING_USER_REGISTER_INTEREST, {
				email: this.email.value,
			});
			await this.registerIntService.Put(this.email.value, {
				email: this.email.value,
			});

			this.onReset();
			this.successful = true;
		} catch (err) {
			console.log('unable to add user to the registered interest list', err);

			LogRocket.captureException(err, { extra: { email: this.email.value } });
			this.snackbar.open(
				'Sorry, we were unable to register the email, please try again!',
			);
		}
	}

	onReset(): void {
		this.submitted = false;
		this.emailForm.reset();
	}
}
